<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-12  transparent-bg">
              <b-card-body id="login-form">
                <b-form>
                  <h1 class="text-light">信用卡授權充電 <img class="navbar-brand-full" src="img/innoknight/logo.png" width="37" height="48" alt="InnoKnight"></h1>
                  <p class="text-light">請輸入以下資料，"*"為必填欄位。您必須輸入正確的Email以確保您會收到系統發送的收據以及充電剩餘點數。</p>
                  <p class="text-light">請預先授權金額，本金額將登記在您的email下，系統在結算後會自動依照實際充電金額扣款，授權金額不足時將自動斷電，剩餘金額將儲存在您的email下以供下次使用。</p>

                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-at"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="email" 
                                  class="form-control" 
                                  placeholder="Email＊" 
                                  v-model.lazy.trim="$v.username.$model"
                                  v-focus
                                  :state="chkState('username')"
                                  aria-describedby="invalidEmailFeedback"
                                  @input="checkEmailExists"
                                  ref="username"/>
                    <b-form-invalid-feedback id="invalidEmailFeedback">請填入有效的Email</b-form-invalid-feedback>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-key"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" 
                                  class="form-control" 
                                  placeholder="統一發票抬頭／售買人姓名＊"
                                  v-model.lazy.trim="$v.buyername.$model"
                                  :state="chkState('buyername')"
                                  aria-describedby="invalidEmailFeedback"
                                  ref="buyername"/>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-key"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" 
                                  v-model.lazy.trim="$v.buyerubn.$model"
                                  :state="chkState('buyerubn')"
                                  class="form-control" 
                                  placeholder="統一編號（非必填）"
                                  ref="buyerubn"/>
                  </b-input-group>

                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-grav"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" 
                                  class="form-control" 
                                  placeholder="認證碼*" 
                                  v-model.lazy.trim="$v.token.$model"
                                  :state="chkState('token')"
                                  aria-describedby="invalidTokenFeedback"
                                  ref="token"/>
                    <b-form-invalid-feedback id="invalidTokenFeedback">請填寫認證碼</b-form-invalid-feedback>
                    <b-button variant="success" :disabled="!($v.username.email&&$v.username.required)" class="px-4" @click="getToken()">取得認證碼</b-button>
                    <span class="d-inline-block w-100 text-warning" v-if="is_get_token_clicked">若您尚未收到驗證碼，請等待90秒再次點擊「取得認證碼」</span>
                  </b-input-group>

                  <b-input-group v-if="showYourOkay" class="mb-3">
                    <b-alert class="col-12" variant="info" show>系統有在您輸入的email下找到帳號，您可以再輸入驗證碼後登入充電</b-alert>

                    <b-button variant="success" class="top-up-btn col-12" @click="loginByEmailAndToken()">登入充電</b-button>
                  </b-input-group>

                  <b-input-group v-if="askForToppingUp">
                    <b-alert class="col-12" variant="warning" show>{{toppingMsg}}</b-alert>
                  </b-input-group>

                  <b-row v-if="askForToppingUp">
                    <div class="col-md-12 col-xs-12 text-center">
                      <b-button variant="" class="top-up-btn" @click="getTransactionForm(50)">授權$60元（約10度）</b-button>
                    </div>
                    <div class="col-md-12 col-xs-12 text-center mt-3">
                      <b-button variant="" class="top-up-btn" @click="getTransactionForm(100)">授權$120元（約20度）</b-button>
                    </div>
                    <div class="col-md-12 col-xs-12 text-center mt-3">
                      <b-button variant="" class="top-up-btn" @click="getTransactionForm(300)">授權$360元（約60度）</b-button>
                    </div>
                    <div class="col-md-12 col-xs-12 text-center mt-3">
                      <b-button variant="" class="top-up-btn" @click="getTransactionForm(600)">授權$720元（約120度）</b-button>
                    </div>
                  </b-row>

                  <b-row>
                    <b-col cols="12" class="text-center text-light" style="padding-top:1.2rem;">
                      <h5 class="d-inline pointer" @click="gotoLogin()"><i class="fa fa-sign-in"></i> 回登入頁面 &nbsp;&nbsp;</h5>
                    </b-col>
                  </b-row>

                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>

    <div class="hidden" id="tmp-form"></div>
  </div>
</template>

<script>
import { required, minLength, between, email, sameAs, maxLength } from 'vuelidate/lib/validators'
import VueNotifications from 'vue-notifications'
import config from '@/config/global'
import notifications from '@/config/notifications'
import _ from 'lodash'

const encrypt  = config.encrypt;
const decrypt  = config.decrypt;
const api_root = config.api_root;

const _defaultNav = [
  { name:'充電裝置', url: '/dashboard/showdevice', icon: 'fa fa-plug' },
  { name:'充電紀錄', url: '/dashboard/history', icon: 'fa fa-bar-chart' },
  { name:'交易紀錄', url: '/dashboard/transactions', icon: 'fa fa-credit-card' },
];

export default {
  name: 'EndUserDirectCharging',
  
  notifications,

  beforeMount() {
  },//eo beforeMount

  data() {

    let username = this.$state.$get('username');
    let buyername = this.$state.$get('buyername');
    let buyerubn = this.$state.$get('buyerubn');

    username = username === 'null' ? '' : username;
    buyername = buyername === 'null' ? '' : buyername;
    buyerubn = buyerubn === 'null' ? '' : buyerubn;

    return {
      username:             username || '',
      buyername:            buyername || '',
      buyerubn:             buyerubn || '',
      name:                 '',
      phone:                '',
      token:                '',
      captcha_action:       '',
      toppingMsg:           '',
      show_capthca:         config.show_capthca,
      captcha_action:       config.captcha_action,
      submit_btn_disabled:  true,
      is_get_token_clicked: false,
      askForToppingUp:      false,
      showYourOkay:         false,
    };
  },//eo data

  mounted() {
    if (this.username && this.chkState('username')) {
      this.getToken();
      this.checkEmailExists();
    }
  }, // eo mounted

  methods: {
    submit(){
      // console.info('submit');return;
      
      let app = this;

      this.$v.$touch();

      if (this.$v.$invalid) {
        this.showError({message:'請依照表單中的欄位填寫資料', timeout: 15000});
        return false;
      }

      grecaptcha.execute(config.captcha_key, {action: 'resetpasswordform'})
      .then(function(ggtoken) {

        let username = app.username;
        let password = app.password;
        let phone    = app.phone;
        let name     = app.name;
        let token    = app.token;

        let action   = `${api_root}/enduser/resetpassword`;
        let params   = {
          keyset: 'mqtt',
          form: encodeURIComponent(encrypt(JSON.stringify({
                username,
                  password,
                  token
                }))),
          frontend:location.origin,
          ggtoken
        };

        app.$jsonp(action, params).then((result) => {
          if(!result.success){
            app.showError({
              message: '系統暫時無法重設密碼，請稍後再試',
              timeout: 15000
            });
          } else {
            app.showSuccess({
              message: `重設密碼成功`,
              timeout: 5000
            });
            app.$router.push('/');
          }
        })//return the Promise
        
      });

      
    },//eo submit
    chkState(val) {
      const field = this.$v[val];
      return !field.$dirty || !field.$invalid;
    },//eo chkState
    gotoLogin() {
      this.$router.push('/');
    },//eo gotoLogin
    gotoResetPassword(){
      this.$router.push('/amnesia');
    },//eo gotoResetPassword
    getToken(){
      let app = this;

      if(app.is_get_token_clicked){
        // app.showWarn({
        //   message: '請稍等90秒再次點擊'
        // });
        return false;
      }

      app.is_get_token_clicked = true;

      let _cc = setTimeout(() => {
        app.is_get_token_clicked = false;
      }, 90000);

      grecaptcha.execute(config.captcha_key, {action: 'resetpassword'})
      .then(function(ggtoken) {

        let username = app.username;
        let action   = `${api_root}/enduser/send_token`;
        let params   = {
          keyset: 'mqtt',
          username: encodeURIComponent(encrypt(JSON.stringify({username}))),
          subject: '重新設定密碼確認信',
          ggtoken,
          action: 'reset-password'
        };

        app.$jsonp(action, params).then((result) => {
          if(!result.success){
            if(result.message === 'MAIL USED'){
              app.showWarn({
                message: `${username}已註冊，請使用「重設密碼」`,
                timeout: 15000
              });
            } else if(result.message === 'MAIL SENT'){
              app.showSuccess({
                message: `已發送驗證碼到${username}，請檢查您的信箱`,
                timeout: 15000
              });
              app.targetToken = result.token;
              app.targetUUID = result.uuid;
              if (result.total) {
                app.showYourOkay = true;
              } else {

                let action   = `${config.mqtt_root}/read_balance`;
                let params   = {
                  token: app.targetToken,
                  user_id: encodeURIComponent(encrypt(`${app.targetUUID}`)),
                  keyset: 'mqtt',
                };

                app.$jsonp(action, params).then((result) => {
                  const balance = (parseInt(result.user.credits) + parseInt(result.user.bonus)) * 1.15;
                  if (result.success
                      && ( balance < 60) ) {
                    app.askForToppingUp = true;
                    if (balance < 60 && balance > 0) {
                      app.toppingMsg = `您的帳戶目前餘額(${balance})不足60元，請您可選擇加值後充電或是使用您剩下的餘額充電`;
                      app.showYourOkay = true;
                    } else if ( balance <= 0) {
                      app.toppingMsg = `您的帳戶目前餘額(${balance})低於0，請先加值後再充電`;
                      app.showYourOkay = true;
                    } 
                  } else {
                    app.askForToppingUp = true;
                    app.toppingMsg = '您的帳戶目前餘額不足60元，請加值後登入充電';
                  }
                });
              }
            } else {
              app.showError({
                message: '系統暫時無法寄送驗證碼，請稍後再試',
                timeout: 15000
              });
            }
          } else {
            app.showSuccess({
              message: `已發送驗證碼到${username}，請檢查您的信箱`,
              timeout: 15000
            });
            app.targetToken = result.token ? result.token : null;
            app.targetUUID = result.uuid;
            // if (result.total) {
            //   app.showYourOkay = true;
            // }
            let action   = `${config.mqtt_root}/read_balance`;
            let params   = {
              token: app.targetToken,
              user_id: encodeURIComponent(encrypt(`${app.targetUUID}`)),
              keyset: 'mqtt',
            };

            app.$jsonp(action, params).then((result) => {
              const balance = (parseInt(result.user.credits) + parseInt(result.user.bonus)) * 1.15;
              if (result.success
                  && ( balance < 60) ) {
                app.askForToppingUp = true;
                if (balance < 60 && balance > 0) {
                  app.toppingMsg = `您的帳戶目前餘額(${balance})不足60元，請您可選擇加值後充電或是使用您剩下的餘額充電`;
                  app.showYourOkay = true;
                } else if ( balance <= 0) {
                  app.toppingMsg = `您的帳戶目前餘額(${balance})低於0，請先加值後再充電`;
                  app.showYourOkay = true;
                } 
              } else {
                app.askForToppingUp = true;
                app.toppingMsg = '您的帳戶目前餘額不足60元，請加值後登入充電';
              }
            });
          }
        })//return the Promise
        
      });

    },//eo getToken
    getTransactionForm(amount){
      let app = this;
      let user = app.$state.$get('user');
      
      if ( !this.buyername ) {
        this.$refs.buyername.focus();
        this.showError({message: '請填入發票買受人名稱'});
        return;
      } else {
        this.$state.$set('buyername', this.buyername);
      }

      if ( !this.username || !this.chkState('username')) {
        this.$refs.username.focus();
        this.showError({message: '請填入有效的Email'});
        return;
      } else {
        this.$state.$set('username', this.username);
      }

      if (!this.token || this.token !== this.targetToken) {
        this.$refs.token.focus();
        this.getToken();
        this.showError({message: '請填入有效的驗證碼以確認是您本人'});
        console.info('this.token: ', this.token, ', this.targetToken: ', this.targetToken);
        return;
      }

      if (this.buyerubn && this.buyerubn.length !== 8) {
        this.buyerubn = '';
        this.$refs.buyerubn.focus();
        this.showError({message: '請填入正確的統一編號'});
        return;
      } else {
        this.$state.$set('buyerubn', this.buyerubn);
      }

      app.showCashFlowLoadingModal = true;
      app.showTopUpModal = false;

      amount *= 1.2;
      
      jQuery.getJSON(`${config.mqtt_root}/render_transaction_form`, {
          user_id: encodeURIComponent(app.$state.$get('user').uuid),
          token: app.$state.$get('user').token,
          backurl: location.href,
          amount,
          callbackName: 'transactionJP',
          buyerubn: this.buyerubn,
          buyername: this.buyername,
          keyset: 'mqtt',
          username: this.username,
      }).done(result => {
          // console.info('render_transaction_form result:', result);

          app.showSuccess({message:'導入藍新科技頁面中，請稍候...'});
          
          if(result.auth && result.success){
              app.showSuccess({message:'加值成功'});
              
              app.$jsonp(`${config.mqtt_root}/read_balance`, {
                  user_id: app.$state.$get('user').uuid,
                  keyset: 'mqtt',
                  token: app.$state.$get('user').token
              }).then((result) => {
                      
                  // console.info('read_balance:', result);
                  
                  if(result.success){
                      app.balance = parseInt(result.user.credits);
                      app.bonus = parseInt(result.user.bonus);
                      
                      user.credits = result.user.credits;
                      user.bonus = result.user.bonus;
                      
                      app.$state.$set('user', user);//update user
                  }
              });
              app.showCashFlowLoadingModal = false;
              return;
          } else if(result.auth) {
              app.showCashFlowLoadingModal = false;
              app.showError({message:'加值失敗，請稍後再試'});
              return;
          }

          if(result.success){
            let form = jQuery(result.form);
            jQuery('#tmp-form').find('#transaction-form').remove();
            jQuery('#tmp-form').append(form).find('#transaction-form').submit();
            // jQuery('#tmp-form').append(form).find('#transaction-form');
          } else {
            app.showError({message:'暫時無法加值，請稍後再試'});
          }
      });
        
    },//eo getTransactionForm
    checkEmailExists: _.debounce(function() {
      if (this.chkState('username')) {

        let username = this.username;
        let action   = `${api_root}/enduser/test_email`;
        let params   = {
          keyset: 'mqtt',
          username: encodeURIComponent(encrypt(JSON.stringify({username}))),
          buyername: this.buyername || '',
          buyerubn: this.buyerubn || '',
          action: 'test-against-email',
        };

        this.$jsonp(action, params).then((result) => {
          if (result.success) {
            this.getToken();
            if (result.duplicate) {
              // login
              if (result.uuid) {
                this.targetUUID = result.uuid;
                this.$state.$set('user', {
                  uuid: encrypt(`${result.uuid}`),
                  token: result.token,
                  ccff: 0,
                  name: this.buyername,
                  username: this.buyername,
                  _nav: _defaultNav,
                });
              }

              if (result.total) {
                this.showYourOkay = true;
              }

              // console.info('this.showYourOkay: ', this.showYourOkay);
            } else {
              // topping up and create account
              this.askForToppingUp = true;
              this.toppingMsg = '系統目前沒有在您的email下找到餘額，請加值後開始充電';
              
              if (result.new_id) {
                this.targetUUID = result.new_id;
                this.$state.$set('user', {
                  uuid: encrypt(`${result.new_id}`),
                  token: result.token,
                  ccff: 0,
                  name: this.buyername,
                  username: this.buyername,
                  _nav: _defaultNav,
                });
              }
            }
          }
        })//return the Promise
      }
    }, 1000),
    loginByEmailAndToken() {
      if ( !this.username || !this.chkState('username')) {
        this.$refs.username.focus();
        this.showError({message: '請填入有效的Email'});
        return;
      } else {
        this.$state.$set('username', this.username);
      }

      if (!this.token || this.token !== this.targetToken) {
        this.$refs.token.focus();
        this.showError({message: '請填入有效的驗證碼以確認是您本人'});
        return;
      }

      if (this.buyername) {
        this.$state.$set('buyername', this.buyername);
      }

      if (this.buyerubn) {
        this.$state.$set('buyerubn', this.buyerubn);
      }

      if (this.token && this.token === this.targetToken) {

        let username = this.username;
        let action   = `${config.mqtt_root}/read_balance`;
        let params   = {
          token: this.token,
          user_id: encodeURIComponent(encrypt(`${this.targetUUID}`)),
          keyset: 'mqtt',
        };

        this.$jsonp(action, params).then((result) => {
          if (result.success) {

            this.$state.$set('user', {
              uuid: result.newUUID,
              token: this.targetToken,
              ccff: 0,
              name: this.buyername,
              username: this.buyername,
              _nav: _defaultNav,
              credits: result.user.credits,
              bonus: result.user.bonus,
            });

            let device_id = this.$state.$get('device_id');
            let pre_uuid = this.$state.$get('uuid');
            let postfix = device_id ? `?uuid=${device_id}` : '';

            console.info(result.user);

            if (pre_uuid) {
              postfix = `?uuid=${encodeURIComponent(pre_uuid)}`;
            }

            // console.info('device: ', device);

            this.$jsonp(`${api_root}/enduser/test_email`, {
              action: 'reset-validation-email',
              keyset: 'mqtt',
              username: encodeURIComponent(encrypt(JSON.stringify({username: this.username}))),
              buyername: this.buyername || '',
            }).then((result) => {});

            this.showSuccess({message:'導入充電頁面中，請稍候...'});
            window.location.href = '/#/dashboard/showdevice' + postfix;

          }
        })//return the Promise

        // console.info('this.targetUUID: ', this.targetUUID);
      }
    },
  },//eo methods

  validations: {
    username: {
      email,
      required,
      minLength: minLength(4)
    },
    buyername: {
      required: true,
    },
    buyerubn: {
      required: false,
      minLength: minLength(8),
      maxLength: maxLength(8),
    },
    token: {
      required,
      minLength: minLength(5)
    },
  }//eo validations
}
</script>

<style>
.card-body{
  padding: 1.25rem !important;
}
.pointer{
  cursor: pointer;
}
.grecaptcha-badge{
  display: none;
}
.top-up-btn{
  height: 5rem;
  max-width: 100%;
  min-width: 100%;
  font-size: 0.9rem;
  margin: 0.5px 0px;
}
</style>
